export enum VariantType {
  COLOR = 'color',
  BUTTON = 'button',
  DROPDOWN = 'dropdown',
}
